import qs from 'qs'
import axios from 'axios'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {message} from 'ant-design-vue'
import store from '../store'
import $ from 'jquery'
import jscookie from "js-cookie";
import { GLOBAL } from '../common/global.func'

function showMessage({msgContent, msgType = 'success'}) {
    if (msgType === 'success') {
        message.success(msgContent)
    } else {
        message.error(msgContent);
    }
}

function ChangeLoadingStatus({apikey, status = true}) {
    // store.commit('ChangeStatus', { apikey, status });
    store.commit({
        type: 'loading/ChangeStatus',
        apikey,
        status
    })
}

function trimValue(params) {
    // console.log(params, "提交的参数")
    for (let key in params) {
        if (params[key] == undefined || typeof params[key] != "string") continue
        params[key] = params[key].trim()
    }
    return params
}

function handleParams(params) {
    let currentHost = window.location.host;
    if (currentHost.indexOf('fp.cnzhonglunnet') != -1 || currentHost.indexOf('fpuat') != -1 || currentHost.indexOf('fpsim') != -1
        || currentHost.indexOf('fpdev') != -1 || currentHost.indexOf('fppet') != -1 || currentHost.indexOf('fpsit') != -1
        || currentHost.indexOf('fppre') != -1 || currentHost.indexOf('fpvip') != -1 || currentHost.indexOf('fppri') != -1
    ) {
        return params
    }
    //本地专用
    let cuser = GLOBAL.getCurrentUser();
    if(cuser){
        params = {
            ...params,
            // 'appcode':'fp_h5-001',
            _ctx:'{"appcode":"fp_h5-001","traceid":"'+getTraceID()+'"}',
            'zl-request-test':cuser.identitykey,
            'fk_id': jscookie.get('fk_id'), //一账通体系时，先在对应环境登录 从 cookie 中获取fk_id 数据
        };
    }
    
    return params
}

function getTraceID(){
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }

    var uuid = 'yxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

    var ts = new Date().Format('yyyyMMddhhmmss');
    return 'T' + ts + 'E' + uuid.toUpperCase();
}



function request({url, params = {}, method = 'post', apikey}) {
    // if (url.indexOf('yapi') != -1) {
    //     //yapi专用
    //     method = 'get'
    // }
    params = handleParams(params)
    NProgress.configure({
        showSpinner: false
    })
    NProgress.start();
    params = trimValue(params)
    ChangeLoadingStatus({apikey, status: true})
    const data = qs.stringify(params)

    //配置axios
    let config = {
        url,
        data,
        method,
        timeout: params.timeout ? params.timeout : 5000,
        // withCredentials: true, //请求的时候是否带上cookie信息
    }
    if (method.toLowerCase() == "get") {
        //只有GET请求才需要params
        config['params'] = params
    }

    return axios.request(config).then(response => {
        // console.log(response, " ==== axios 中的response ====")
        const {data = {}} = response
        if (data.success != '1' && data.code == undefined && data.recordsTotal == undefined && response.config.url.indexOf('/svn/get_all_branches') == -1) {
            if(data.errorCode == "100001"){
                GLOBAL.logout();
            }
            showMessage({
                msgType: data.success == '1' ? 'success' : 'error',
                msgContent: data.message ? data.message : data.errorMsg,
                // response
            })
        }

        ChangeLoadingStatus({apikey, status: false})
        NProgress.done();
        return response
    }).catch(error => {
        ChangeLoadingStatus({apikey, status: false})
        NProgress.done();
        console.log(error.response, " ==== axios 中的error ====")
        const {status, statusText} = error.response
        showMessage({
            msgContent: `远程服务器错误 | 错误码: ${status} | 错误描述: ${statusText}`,
            msgType: 'error'
        })
        throw new Error(error);
    });
}

//同步请求 - 如果操作交互, 下一步依赖上一步的操作, 请使用同步方法请求. then中嵌套太多的话也应该使用 同步请求 指定sync: true
//this.props.dispatch({type: 'xxx/xxx', payload: objectValues, sync: true})
function syncRequest({url, params = {}, extra = {}}) {
    let method = extra.method ? extra.method : 'post'
    NProgress.configure({
        showSpinner: false
    })
    NProgress.start();
    params = trimValue(params)
    // ChangeLoadingStatus({ type, status: true })

    let result = {};

    params = handleParams(params, url)
    $.ajax({
        url,
        method,
        async: false, //强制指定为同步请求
        timeout: extra.timeout, //超时设定
        dataType: 'json', //指定数据返回格式
        data: qs.stringify(params),
        cache: false, //禁用缓存 - 解决IE下的问题
        xhrFields: {
            withCredentials: false, //跨域下使用
        },
        success: function (data) {
            NProgress.done();
            if (data.success != '1') {
                // this.message.error(data.errorMsg)
            } else {
                result = data;
            }
        },
        error: function (error) {
            NProgress.done();
            this.message.error(error.statusText)
        },
    })
    if (result["success"] != "1") {
        throw new Error("同步请求失败，程序终止执行……")
    }
    return result;
}

export {
    request,
    syncRequest
}
